<template>
  <div align="center">
    <div
      v-if="!isMobile"
      class="detail"
      style="width: 70%;max-width: 80%; alignment: center;margin-top:50px"
    >
      <h1 style="font-weight: bold" align="center">客户服务详情单</h1>
      <a-row>
        <a-col :span="12" align="left">客户名称:{{ this.data[0].cname }}</a-col>
        <a-col :span="12" align="left">单据编号:{{ this.data[0].billNo }}</a-col>
      </a-row>
      <a-row>
        <a-col :span="12" align="left">客户编码:{{ this.data[0].cnumber }}</a-col>
        <a-col :span="12" align="left">销售订单:{{ this.data[0].salesOrder }}</a-col>
      </a-row>
      <a-row>
        <a-col :span="12" align="left">销售部门:{{ this.data[0].salesDept }}</a-col>
        <a-col :span="12" align="left">服务日期:{{ this.data[0].serviceDate }}</a-col>
      </a-row>
      <a-row>
        <a-col :span="12" align="left">销售人员:{{ this.data[0].salesPeople }}</a-col>
        <a-col :span="12" align="left">订单日期:{{ this.data[0].orderDate }}</a-col>
      </a-row>
      <a-row>
        <a-col :span="24" align="left">维修状态:{{ this.data[0].fstatus }}</a-col>
      </a-row>
      <br />
      <a-row>
        <a-col align="left" style="font-weight: bold">客户反馈与要求:</a-col>
      </a-row>
      <a-row>
        <a-col align="left">{{ this.data[0].requirement }}</a-col>
      </a-row>
      <a-row>
        <a-col align="left" style="font-weight: bold">原因阐述:</a-col>
      </a-row>
      <a-row>
        <a-col align="left">{{ this.data[0].processResult }}</a-col>
      </a-row>
      <a-row>
        <a-col align="left" style="font-weight: bold">服务内容描述:</a-col>
      </a-row>
      <a-row>
        <!--        <a-col :span="4" align="left">产品代码</a-col>-->
        <a-col :span="3" align="left" style="font-weight: bold">产品型号</a-col>
        <a-col :span="3" align="left" style="font-weight: bold">产品名称</a-col>
        <a-col :span="3" align="left" style="font-weight: bold">更换模块</a-col>
        <a-col :span="3" align="left" style="font-weight: bold">质保符合</a-col>
        <a-col :span="3" align="left" style="font-weight: bold">服务方式</a-col>
        <a-col :span="3" align="left" style="font-weight: bold">数量</a-col>
        <a-col :span="3" align="left" style="font-weight: bold">维修报价</a-col>
        <a-col :span="3" align="left" style="font-weight: bold">维修总价</a-col>
      </a-row>
      <a-row v-for="(item) in this.data" :key="item.productCode">
        <!--        <a-col :span="4" align="left">{{ item.productNumber }}</a-col>-->
        <a-col :span="3" align="left">{{ item.productCode }}</a-col>
        <a-col :span="3" align="left">{{ item.productDescription }}</a-col>
        <a-col :span="3" align="left">{{ item.ftype }}</a-col>
        <a-col :span="3" align="left">{{ item.warranty }}</a-col>
        <a-col :span="3" align="left">{{ item.serviceMethod }}</a-col>
        <a-col :span="3" align="left">{{ item.faultNumber }}</a-col>
        <a-col :span="3" align="left">{{ item.price }}</a-col>
        <a-col :span="3" align="left">{{ item.totalPrice }}</a-col>
      </a-row>
      <br />
      <div align="left" style="font-weight: bold">物流单号:{{ this.data[0].logisticsNo }}</div>
      <br />

      <a-row>
        <a-col :span="20" align="right">合计</a-col>
        <a-col :span="4" align="right">{{ this.data[0].total }}</a-col>
      </a-row>
      <a-row>
        <a-col :span="20" align="right">增值税合计</a-col>
        <a-col :span="4" align="right">{{ this.data[0].tax }}</a-col>
      </a-row>
      <a-row>
        <a-col :span="20" align="right">总计含税人民币</a-col>
        <a-col :span="4" align="right">{{ this.data[0].taxToal }}</a-col>
      </a-row>
      <br />

      <div align="left" style="font-weight: bold">服务条款：</div>
      <div align="left">以上海南华机电有限公司的客户售后服务条款为基准，根据不同部件的质保期限的要求进行服务。在质保期限内的产品我们将免费提供服务并交付维修品。</div>
      <div align="left">
        超过质保期限的产品，我们将进行相应费用的收取，具体内容见上述表单。服务条款请参阅
        <a href="aftersaleServicePdf">此处</a>
      </div>
      <br />

      <a-row>
        <a-col align="left" :span="4">Certificae of Conformity</a-col>
        <a-col align="left" :span="20">
          The whole of the supplier detailed hereon confirm to customer purchase order
          requirements and have been
          processed fully within the controls detailed in our quality management system that complies with and is fully
          accredited to ISO9001:2015 certified by DNV
        </a-col>
      </a-row>
      <br />
      <a-row>
        <a-col align="left" :span="4">上海南华机电有限公司</a-col>
        <a-col align="left" :span="10">Telephone: +86-21-3912 6868</a-col>
        <a-col align="right" :span="10">税务帐号: 913101146972772000</a-col>
      </a-row>
      <a-row>
        <a-col align="left" :span="4"></a-col>
        <a-col align="left" :span="10">Fascimile: +86-21-3912 6868-808</a-col>
        <a-col align="right" :span="10">开户行：中国建设银行上海市南翔支行</a-col>
      </a-row>
      <br />
      <a-row>
        <a-col align="left" :span="4">中国上海</a-col>
        <a-col align="left" :span="10">Email: sales@nanhua.com</a-col>
        <a-col align="right" :span="10">开户行号码：105290079054</a-col>
      </a-row>
      <br />
      <a-row>
        <a-col align="left" :span="5">嘉定区蕴北路1755弄9号</a-col>
        <a-col align="left" :span="9">
          <a href="http://www.nanhua.com">www.nanhua.com</a>
        </a-col>
        <a-col align="right" :span="10">开户名称：上海南华机电有限公司</a-col>
      </a-row>
      <a-row>
        <a-col align="right" :span="24">银行帐号IBAN：31001975910050008802</a-col>
      </a-row>
    </div>

    <!-- 小屏 -->
    <div v-else class="detail" style="width: 70%;max-width: 80%; alignment: center;margin-top:50px">
      <h1 style="font-weight: bold" align="center">客户服务详情单</h1>
      <a-row>
        <a-col :span="24" align="left">客户名称:{{ this.data[0].cname }}</a-col>
      </a-row>
      <a-row>
        <a-col :span="24" align="left">单据编号:{{ this.data[0].billNo }}</a-col>
      </a-row>
      <a-row>
        <a-col :span="24" align="left">客户编码:{{ this.data[0].cnumber }}</a-col>
      </a-row>
      <a-row>
        <a-col :span="24" align="left">销售订单:{{ this.data[0].salesOrder }}</a-col>
      </a-row>
      <a-row>
        <a-col :span="24" align="left">销售部门:{{ this.data[0].salesDept }}</a-col>
      </a-row>
      <a-row>
        <a-col :span="24" align="left">服务日期:{{ this.data[0].serviceDate }}</a-col>
      </a-row>
      <a-row>
        <a-col :span="24" align="left">销售人员:{{ this.data[0].salesPeople }}</a-col>
      </a-row>
      <a-row>
        <a-col :span="24" align="left">订单日期:{{ this.data[0].orderDate }}</a-col>
      </a-row>
      <a-row>
        <a-col :span="24" align="left">维修状态:{{ this.data[0].fstatus }}</a-col>
      </a-row>
      <br />
      <a-row>
        <a-col align="left" style="font-weight:bold">客户反馈与要求:</a-col>
      </a-row>
      <a-row>
        <a-col align="left">{{ this.data[0].requirement }}</a-col>
      </a-row>
      <a-row>
        <a-col align="left" style="font-weight:bold">原因阐述:</a-col>
      </a-row>
      <a-row>
        <a-col align="left">{{ this.data[0].processResult }}</a-col>
      </a-row>
      <a-row>
        <a-col align="left" style="font-weight:bold">服务内容描述:</a-col>
      </a-row>
      <a-row v-for="(item) in this.data" :key="item.productCode">
        <!--        <a-col :span="4" align="left">产品代码</a-col>-->
        <a-col :span="24" align="left">产品型号:{{ item.productCode }}</a-col>
        <a-col :span="24" align="left">产品名称:{{ item.productDescription }}</a-col>
        <a-col :span="24" align="left">更换模块:{{ item.ftype }}</a-col>
        <a-col :span="24" align="left">质保符合:{{ item.warranty }}</a-col>
        <a-col :span="24" align="left">服务方式:{{ item.serviceMethod }}</a-col>
        <a-col :span="24" align="left">数量:{{ item.faultNumber }}</a-col>
        <a-col :span="24" align="left">维修报价:{{ item.price }}</a-col>
        <a-col :span="24" align="left">维修总价:{{ item.totalPrice }}</a-col>
      </a-row>
      <br />
      <div align="left" style="font-weight:bold">物流单号:{{ this.data[0].logisticsNo }}</div>
      <br />

      <a-row>
        <a-col :span="20" align="left">合计</a-col>
        <a-col :span="4" align="left">{{ this.data[0].total }}</a-col>
      </a-row>
      <a-row>
        <a-col :span="20" align="left">增值税合计</a-col>
        <a-col :span="4" align="left">{{ this.data[0].tax }}</a-col>
      </a-row>
      <a-row>
        <a-col :span="20" align="left">总计含税人民币</a-col>
        <a-col :span="4" align="left">{{ this.data[0].taxToal }}</a-col>
      </a-row>
      <br />

      <div align="left" style="font-weight:bold">服务条款：</div>
      <div align="left">以上海南华机电有限公司的客户售后服务条款为基准，根据不同部件的质保期限的要求进行服务。在质保期限内的产品我们将免费提供服务并交付维修品。</div>
      <div align="left">
        超过质保期限的产品，我们将进行相应费用的收取，具体内容见上述表单。服务条款请参阅
        <a href="aftersaleServicePdf">此处</a>
      </div>
      <br />

      <a-row>
        <a-col align="left" :span="24">Certificae of Conformity</a-col>
        <a-col align="left" :span="24">
          The whole of the supplier detailed hereon confirm to customer purchase order
          requirements and have been
          processed fully within the controls detailed in our quality management system that complies with and is fully
          accredited to ISO9001:2015 certified by DNV
        </a-col>
      </a-row>
      <br />
      <a-row>
        <a-col align="left" :span="24">上海南华机电有限公司</a-col>
        <a-col align="left" :span="24">Telephone: +86-21-3912 6868</a-col>
        <a-col align="left" :span="24">税务帐号: 913101146972772000</a-col>
      </a-row>
      <a-row>
        <a-col align="left" :span="24"></a-col>
        <a-col align="left" :span="24">Fascimile: +86-21-3912 6868-808</a-col>
        <a-col align="left" :span="24">开户行：中国建设银行上海市南翔支行</a-col>
      </a-row>
      <br />
      <a-row>
        <a-col align="left" :span="24">中国上海</a-col>
        <a-col align="left" :span="24">Email: sales@nanhua.com</a-col>
        <a-col align="left" :span="24">开户行号码：105290079054</a-col>
      </a-row>
      <br />
      <a-row>
        <a-col align="left" :span="24">嘉定区蕴北路1755弄9号</a-col>
        <a-col align="left" :span="24">
          <a href="http://www.nanhua.com">www.nanhua.com</a>
        </a-col>
        <a-col align="left" :span="24">开户名称：上海南华机电有限公司</a-col>
      </a-row>
      <a-row>
        <a-col align="left" :span="24">银行帐号IBAN：31001975910050008802</a-col>
      </a-row>
    </div>
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: "aftersaleService",
  data() {
    return {
      data: [{}],
      isMobile: false
    };
  },
  components: {},
  beforeMount() {},
  mounted() {
    if (window.matchMedia("(max-width: 1270px)").matches) {
      this.isMobile = true;
    } else {
      this.isMobile = false;
    };
    axios
      .get(
        "http://www.tcnanhua.com:5555/t-nh-aftersaleservice/selectTNhAftersaleserviceByBillNo?fbillno=" +
          this.$route.query.fbillno
      )
      .then(resp => {
        this.data = resp.data.data;
      });
  },
  methods: {}
};
</script>

<style scoped>
.detail {
  display: flex;
  flex-direction: column;
}
</style>



// WEBPACK FOOTER //
// src/components/AftersaleService.vue